import { ThemeNames } from '../themeTypes';
import lms from './lms';
import portal from './portal';
import retail from './retail';

export default {
  [ThemeNames.LMS]: lms,
  [ThemeNames.PORTAL]: portal,
  [ThemeNames.RETAIL]: retail,
};
